import { render, staticRenderFns } from "./make-price-audit-dialog.vue?vue&type=template&id=b0171ade&scoped=true&"
import script from "./make-price-audit-dialog.vue?vue&type=script&lang=js&"
export * from "./make-price-audit-dialog.vue?vue&type=script&lang=js&"
import style0 from "./make-price-audit-dialog.vue?vue&type=style&index=0&id=b0171ade&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0171ade",
  null
  
)

export default component.exports